import { render, staticRenderFns } from "./ClosuresList.vue?vue&type=template&id=3ca5c149&"
import script from "./ClosuresList.vue?vue&type=script&lang=js&"
export * from "./ClosuresList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VBtn,VPagination})
